module.exports = __webpack_public_path__ + "static/team_paresh-4c7728538440177ec657509709fe0869.jpg";